import { useState, useEffect, useRef } from 'react'
import { Link, useSearchParams, useLocation, useNavigate } from 'react-router-dom'
import { api } from '../lib/api'

export default function ResetPassword() {
  const navTimerRef = useRef<number | undefined>(undefined)
  useEffect(() => () => { if (navTimerRef.current) clearTimeout(navTimerRef.current) }, [])

  const [params]   = useSearchParams()
  const location   = useLocation()
  const navigate   = useNavigate()

  // Token comes from navigation state (after MFA verification) or URL param (legacy)
  const token = (location.state as any)?.token ?? params.get('token') ?? ''

  const [password,  setPassword]  = useState('')
  const [confirm,   setConfirm]   = useState('')
  const [status,    setStatus]    = useState<'idle'|'loading'|'done'|'error'>('idle')
  const [msg,       setMsg]       = useState('')

  async function handleSubmit() {
    if (password !== confirm) { setMsg('Passwords do not match'); setStatus('error'); return }
    if (password.length < 8)  { setMsg('Password must be at least 8 characters'); setStatus('error'); return }
    setStatus('loading'); setMsg('')
    try {
      await api.auth.resetPassword(token, password)
      setStatus('done')
      navTimerRef.current = window.setTimeout(() => navigate('/login'), 2500)
    } catch (e: any) {
      setMsg(e.message)
      setStatus('error')
    }
  }

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '.75rem', color: 'var(--red)', marginBottom: 16 }}>Invalid reset session</div>
          <Link to="/forgot-password" style={{ fontFamily: 'Syne Mono', fontSize: '.65rem', color: 'var(--cash)', textDecoration: 'none' }}>Request a new code →</Link>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/" style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '1.4rem', color: 'var(--bill)', textDecoration: 'none' }}>
            Polywally<span style={{ fontFamily: 'Syne Mono', fontSize: '0.38rem', color: 'var(--cash)', verticalAlign: 'super', marginLeft: 2 }}>™</span>
          </Link>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '0.6rem', letterSpacing: '0.2em', color: 'var(--muted)', marginTop: 4 }}>NEW PASSWORD</div>
        </div>

        <div style={{ background: 'var(--card)', border: '1px solid var(--edge)', borderRadius: 4, padding: 28 }}>
          {status === 'done' ? (
            <div style={{ textAlign: 'center' }}>
              <img src="/icons/check.svg" alt="" style={{width:36,height:36,marginBottom:16}}/>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: '.95rem', color: 'var(--bill)', marginBottom: 10 }}>Password updated</div>
              <div style={{ fontFamily: 'Syne Mono', fontSize: '.65rem', color: 'var(--muted)', lineHeight: 1.8 }}>Redirecting to sign in...</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ fontFamily: 'Syne Mono', fontSize: '.65rem', color: 'var(--muted)', lineHeight: 1.7 }}>
                ✓ Identity verified. Choose a new password.
              </div>
              {status === 'error' && (
                <div style={{ fontFamily: 'Syne Mono', fontSize: '.68rem', color: 'var(--red)', background: 'rgba(224,92,92,.07)', border: '1px solid rgba(224,92,92,.2)', borderRadius: 2, padding: '8px 10px' }}>{msg}</div>
              )}
              <input
                type="password" placeholder="New password (min 8 chars)" value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ background: 'var(--paper)', border: '1px solid var(--edge)', borderRadius: 2, padding: '10px 13px', color: 'var(--text)', fontFamily: 'Syne Mono', fontSize: '0.78rem', outline: 'none' }}
              />
              <input
                type="password" placeholder="Confirm new password" value={confirm}
                onChange={e => setConfirm(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                style={{ background: 'var(--paper)', border: '1px solid var(--edge)', borderRadius: 2, padding: '10px 13px', color: 'var(--text)', fontFamily: 'Syne Mono', fontSize: '0.78rem', outline: 'none' }}
              />
              <button onClick={handleSubmit} disabled={status === 'loading'} style={{ padding: '10px', background: 'var(--cash)', color: 'var(--ink)', border: 'none', borderRadius: 2, fontFamily: 'Syne', fontWeight: 800, fontSize: '0.8rem', cursor: 'pointer', opacity: status === 'loading' ? .5 : 1 }}>
                {status === 'loading' ? 'Updating...' : 'Update Password →'}
              </button>
              <div style={{ textAlign: 'center', fontFamily: 'Syne Mono', fontSize: '.65rem', color: 'var(--muted)' }}>
                <Link to="/login" style={{ color: 'var(--cash)', textDecoration: 'none' }}>← Back to sign in</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
